import { render, staticRenderFns } from "./DefaultMenu.vue?vue&type=template&id=819a3202&"
import script from "./DefaultMenu.vue?vue&type=script&lang=js&"
export * from "./DefaultMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports